import React from "react";
import LineIcon from "./LineIcon";

const BookingHeader = ({
  bookingStep,
  onClose,
}) => {
  return (
    <header className="be-booking-page-header">
      <div className="be-booking-page-header-inner">

        {/* =====================================================
            BACK
        ===================================================== */}

        <button
          type="button"
          className="be-booking-back"
          onClick={onClose}
        >
          <span className="be-booking-back-icon">
            ←
          </span>

          <span>
            Back to rooms
          </span>
        </button>

        {/* =====================================================
            PROGRESS
        ===================================================== */}

        <div className="be-booking-progress">

          {/* STEP 1 — YOUR DETAILS */}

          <div
            className={`be-progress-step ${
              bookingStep !== "details"
                ? "completed"
                : "active"
            }`}
          >
            <span className="be-progress-number">
              {bookingStep !== "details" ? (
                <LineIcon
                  type="check"
                  size={14}
                />
              ) : (
                "1"
              )}
            </span>

            <span>
              Your details
            </span>
          </div>

          {/* LINE */}

          <div
            className={`be-progress-line ${
              bookingStep !== "details"
                ? "active"
                : ""
            }`}
          />

          {/* STEP 2 — REVIEW */}

          <div
            className={`be-progress-step ${
              bookingStep === "review"
                ? "active"
                : bookingStep === "confirmation"
                  ? "completed"
                  : ""
            }`}
          >
            <span className="be-progress-number">
              {bookingStep === "confirmation" ? (
                <LineIcon
                  type="check"
                  size={14}
                />
              ) : (
                "2"
              )}
            </span>

            <span>
              Review
            </span>
          </div>

          {/* LINE */}

          <div
            className={`be-progress-line ${
              bookingStep === "confirmation"
                ? "active"
                : ""
            }`}
          />

          {/* STEP 3 — CONFIRMATION */}

          <div
            className={`be-progress-step ${
              bookingStep === "confirmation"
                ? "active"
                : ""
            }`}
          >
            <span className="be-progress-number">
              3
            </span>

            <span>
              Confirmation
            </span>
          </div>

        </div>

        {/* =====================================================
            CLOSE
        ===================================================== */}

        <button
          type="button"
          className="be-booking-page-close"
          onClick={onClose}
          aria-label="Close booking"
        >
          <LineIcon
            type="close"
            size={20}
          />
        </button>

      </div>
    </header>
  );
};

export default BookingHeader;